import type { SVGProps } from 'react';
export const IconPointsShops = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17014_41029)">
      <path
        d="M18 19.5C20.4853 19.5 22.5 17.4853 22.5 15C22.5 12.5147 20.4853 10.5 18 10.5C15.5147 10.5 13.5 12.5147 13.5 15C13.5 17.4853 15.5147 19.5 18 19.5Z"
        fill="white"
      />
      <path
        d="M18 0.375C27.734 0.375 35.625 8.26598 35.625 18C35.625 27.734 27.734 35.625 18 35.625C8.26598 35.625 0.375 27.734 0.375 18C0.375 8.26598 8.26598 0.375 18 0.375Z"
        fill="#2D2718"
        stroke="#F7F5E9"
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5602 14.1791H12.001V20.2687C11.961 22.1791 13.1048 26 18 26C22.8952 26 24.039 22.1791 23.999 20.2687V14.1791H19.4398V19.0748C19.4398 19.8687 19.453 20.7993 18.7901 21.2363C18.5845 21.3719 18.3242 21.4627 18 21.4627C17.6758 21.4627 17.4155 21.3719 17.2099 21.2363C16.547 20.7993 16.5602 19.8687 16.5602 19.0748V14.1791Z"
        fill="#F7F5E9"
      />
      <path
        d="M19.4787 12.9851H16.7465C16.6416 12.9851 16.5541 12.9038 16.5499 12.799C16.5038 11.6413 16.794 10.6039 16.9889 10.1179C17.0181 10.0452 17.0895 10 17.1679 10H19.4787C19.5892 10 19.6787 10.0895 19.6787 10.2V12.7851C19.6787 12.8955 19.5892 12.9851 19.4787 12.9851Z"
        fill="#F7F5E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_17014_41029">
        <rect
          width={36}
          height={36}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
